/**
 * Horizon overrides for Shopify.actions:
 * - updateCart: emit events from the cart drawer scope.
 * - openCart: DISABLED for Candles by Kash.
 *
 * The platform calls Shopify.actions.openCart() after an add-to-cart. We do
 * not want the drawer taking over the page mid-browse, so this handler shows
 * the brand toast instead of opening anything.
 *
 * The header cart button is unaffected: it uses the theme's declarative
 * binding on:click="#cart-drawer/toggle" (see snippets/header-actions.liquid),
 * which talks to <theme-drawer> directly and never routes through this action.
 */

function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart.configure({
    eventTarget: () => document.querySelector('theme-drawer#cart-drawer') ?? document,
  });

  actions.openCart.configure({
    async handler() {
      if (typeof window.kashToast === 'function') {
        window.kashToast();
      }
    },
  });
}

// Run immediately if the standard-actions bundle has already attached
// `Shopify.actions`; otherwise wait for DOMContentLoaded, which fires after
// all module scripts have executed regardless of document order.
if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}
